import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { logout } from "../../actions/user"
import { toast } from 'react-toastify';
import { withRouter, Link } from 'react-router-dom';
import { clearCartInfo} from '../../actions/cart'
import { clearOrderInfo } from '../../actions/checkout'


class Logout extends Component {

     componentDidMount() {
 this.props.clearCartInfo();
         this.props.clearOrderInfo();
         this.props.logout(this.props.connection_id);
          localStorage.removeItem('mobile_no');
         toast.error("You have been logged out.");
         this.props.history.push('/')
     }

//     componentDidMount() {

//     this.props.clearCartInfo();

//     this.props.clearOrderInfo();

//     this.props.logout(this.props.connection_id);

//     localStorage.removeItem('mobile_no');

//     sessionStorage.clear();

//     toast.error("You have been logged out.");

//     setTimeout(() => {

//         window.location.href = "/";

//     }, 500);
// }

    render() {
        return (
      
            <div className="col-sm-12 text-center pb-5" style={{paddingTop: "4rem"}}>
                {/* <img src={`${process.env.PUBLIC_URL}/assets/images/empty-search.jpg`} className="img-fluid mb-4" /> */}
                <h3 style={{paddingBottom: "4rem"}}>You have been logged out successfully!</h3>
                <Link to={`${process.env.PUBLIC_URL}/`} className="btn btn-solid">continue shopping!</Link>
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    // products: getVisibleproducts(state.data, state.filters),
    isAuth: state.user.isAuth,
    connection_id: state.tenant.connection_id
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { logout, clearCartInfo, clearOrderInfo },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Logout));